import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { persistStore } from 'redux-persist'


export default function configureStore (initialState) {
  let store = createStore(
  		rootReducer,
        initialState,
        applyMiddleware(thunk)
        );
  let persistor = persistStore(store);

  return { persistor, store }
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js